import React from "react";
import {Card, Pagination, Row, Table} from "antd";

const DefaultTableCard = ({
                              columns,
                              data = [],
                              total = 0,
                              currentPage = 0,
                              pagesize = 0,
                              loading = false,
                              onPageChange
                          }) => {

    const handlePageChange = (page, size) => {
        onPageChange && onPageChange(page, size)
    }

    return (
        <Card style={{marginTop: 10, padding: 0}}>
            <Table columns={columns} dataSource={data} bordered pagination={false} loading={loading} scroll={{x: 667}}/>
            <Row justify="end">
                <Pagination
                    simple
                    current={currentPage}
                    disabled={loading}
                    hideOnSinglePage={true}
                    style={{marginTop: 20}}
                    total={total}
                    pageSize={pagesize}
                    showSizeChanger={false}
                    showTotal={total => `共${total}条`}
                    onChange={handlePageChange}
                />
            </Row>
        </Card>
    )
}

export default DefaultTableCard